export var showPoints = function (gameFormatId) {
    return stablefordFormats.includes(gameFormatId);
};
var GameFormats;
(function (GameFormats) {
    GameFormats[GameFormats["UNDEFINED"] = 0] = "UNDEFINED";
    GameFormats[GameFormats["NO_SIDE"] = 1] = "NO_SIDE";
    GameFormats[GameFormats["STROKE_PLAY_INDIVIDUAL"] = 2] = "STROKE_PLAY_INDIVIDUAL";
    GameFormats[GameFormats["STROKE_PLAY_BETTER_BALL"] = 4] = "STROKE_PLAY_BETTER_BALL";
    GameFormats[GameFormats["STROKE_PLAY_BEST_BALL"] = 5] = "STROKE_PLAY_BEST_BALL";
    GameFormats[GameFormats["STROKE_PLAY_SCRAMBLE"] = 8] = "STROKE_PLAY_SCRAMBLE";
    GameFormats[GameFormats["STROKE_PLAY_SCRAMBLE_2_MAN"] = 11] = "STROKE_PLAY_SCRAMBLE_2_MAN";
    GameFormats[GameFormats["STROKE_PLAY_ERADO"] = 6] = "STROKE_PLAY_ERADO";
    GameFormats[GameFormats["STROKE_PLAY_SKINS"] = 13] = "STROKE_PLAY_SKINS";
    GameFormats[GameFormats["STROKE_PLAY_LOW_SCRATCH_NET"] = 14] = "STROKE_PLAY_LOW_SCRATCH_NET";
    GameFormats[GameFormats["STROKE_PLAY_GREENSOME"] = 17] = "STROKE_PLAY_GREENSOME";
    GameFormats[GameFormats["STROKE_PLAY_FOURSOME"] = 19] = "STROKE_PLAY_FOURSOME";
    GameFormats[GameFormats["STROKE_PLAY_COLLEGE"] = 22] = "STROKE_PLAY_COLLEGE";
    GameFormats[GameFormats["STABLEFORD_INDIVIDUAL"] = 3] = "STABLEFORD_INDIVIDUAL";
    GameFormats[GameFormats["STABLEFORD_INDIVIDUAL_DUPLICATE"] = 9] = "STABLEFORD_INDIVIDUAL_DUPLICATE";
    GameFormats[GameFormats["STABLEFORD_BETTER_BALL"] = 15] = "STABLEFORD_BETTER_BALL";
    GameFormats[GameFormats["STABLEFORD_BEST_BALL"] = 7] = "STABLEFORD_BEST_BALL";
    GameFormats[GameFormats["STABLEFORD_SCRAMBLE_DUPLICATE"] = 12] = "STABLEFORD_SCRAMBLE_DUPLICATE";
    GameFormats[GameFormats["STABLEFORD_GREENSOME"] = 16] = "STABLEFORD_GREENSOME";
    GameFormats[GameFormats["STABLEFORD_FOURSOME"] = 18] = "STABLEFORD_FOURSOME";
    GameFormats[GameFormats["MATCH_PLAY_INDIVIDUAL"] = 23] = "MATCH_PLAY_INDIVIDUAL";
    GameFormats[GameFormats["MATCH_PLAY_BETTER_BALL"] = 24] = "MATCH_PLAY_BETTER_BALL";
    GameFormats[GameFormats["MATCH_PLAY_SCRAMBLE"] = 25] = "MATCH_PLAY_SCRAMBLE";
    GameFormats[GameFormats["MATCH_PLAY_GREENSOME"] = 27] = "MATCH_PLAY_GREENSOME";
    GameFormats[GameFormats["MATCH_PLAY_FOURSOME"] = 28] = "MATCH_PLAY_FOURSOME";
    GameFormats[GameFormats["IRISH_RUMBLE_BEST_BALL"] = 20] = "IRISH_RUMBLE_BEST_BALL";
    GameFormats[GameFormats["TEAM_PAR_IS_YOUR_FRIEND"] = 21] = "TEAM_PAR_IS_YOUR_FRIEND";
})(GameFormats || (GameFormats = {}));
var stablefordFormats = [
    GameFormats.STABLEFORD_BETTER_BALL,
    GameFormats.STABLEFORD_GREENSOME,
    GameFormats.STABLEFORD_FOURSOME,
    GameFormats.STABLEFORD_BEST_BALL,
    GameFormats.STABLEFORD_SCRAMBLE_DUPLICATE,
    GameFormats.STABLEFORD_INDIVIDUAL_DUPLICATE,
    GameFormats.STABLEFORD_INDIVIDUAL,
];
